import { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { AppContext } from "../../appContext/AppContext";
import { CODE, DEFAULT_PAGE_INDEX, KEY, SELECTION_MODE, WF_TRACKER } from "../../utils/Constant";
import { Button } from "react-bootstrap";
import TextField from "../../component/TextField";
import InputSearch from "../../component/InputSearch";
import { TableCustom } from "../../component/table/table-custom/TableCustom";
import CustomIconButton from "../../component/custom-icon-button/CustomIconButton";
import { TableCustomHeader } from "../../component/table/components/TableCustomHeader";
import { TablePagination } from "../../component/table/components/TablePagination";
import { handlePagesChange, handleRowsPerPageChange, rowsForPage } from "../../utils/PageUtils";
import WfStatusSummary from "../../workflows/components/WfStatusSummary";
import { BSCoSoTuTrucColumns, DanhSachPhieuColumns } from "../constants/TuTrucColumns";
import DialogThemPhieuTuTruc from "./DialogThemPhieuTuTruc";
import { ConfirmDialog } from "../../component/ConfirmDialog";
import { PhanHeTuTrucContext } from "../PhanHeTuTruc";
import { deletePhieuTuTruc, searchPhieuTuTruc } from "../services/TuTrucServices";
import { toast } from "react-toastify";
import { getSummaryStatusByIdWarehouse } from "../../workflows/services/WfWorkflowsService";
import { formatDateFromDTOCustom, formatDateToDTOCustom } from "../../utils/AppFunction";
import { WMS_STATUS } from "../../phan-he-nhap-kho/constants/constansNhapKho";
import { localStorageItem } from "../../utils/LocalStorage";
import { withBarcodeScan } from "@oceantech/oceantech-ui";

type Props = {
  modelId?: any;
  typeTuTruc?: any;
  barcode?: any;
}

export const BoSungCoSoTuTruc: FC<Props> = (props: Props) => {
  const { modelId, typeTuTruc, barcode = "" } = props;
  const SITE = process.env.REACT_APP_SITE;
  const { setIsLoading } = useContext(AppContext);
  const { tuTrucCurrent, setDsVatTu } = useContext(PhanHeTuTrucContext);
  const [dsPhieuTuTruc, setDsPhieuTuTruc] = useState([]);
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState(false);
  const [openDialogConfirmDelete, setOpenDialogConfirmDelete] = useState<boolean>(false);
  const [itemSelected, setItemSelected] = useState<any>({});
  const [searchData, setSearchData] = useState<any>();
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
  const [summaryStatus, setSummaryStatus] = useState<any>([]);
  const [configTable, setConfigTable] = useState<any>({
    totalPages: 0,
    totalElements: 0,
    numberOfElements: 0,
  });
  const dataUser = localStorageItem.get("current-user");

  useEffect(() => {
    updatePageData();
  }, [page, rowsPerPage, modelId?.whIssueId, modelId.type, tuTrucCurrent]);

  useEffect(() => {
    if (modelId.title) return;
    let icons = document.querySelectorAll<HTMLElement>("i.bi-pencil-square")
    Array.from(icons).forEach((item: HTMLElement) => item.style.marginRight = "0")
  })

  useEffect(() => {
    if (!modelId.title) return;
    let element = document.getElementById("inf-pagination")
    if (!element) return;
    element.style.position = "absolute";
    element.style.bottom = "0";
    element.style.right = "0";
  }, [modelId])

  const handleChangeSearchData = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };

  const getDataSumary = async (idWarehouse: number) => {
    if (modelId.title && !idWarehouse) return; // k goi o tu truc khi k co id
    const resSummary = await getSummaryStatusByIdWarehouse(WF_TRACKER.BO_SUNG_CO_SO_TU_TRUC, modelId.type, idWarehouse, modelId.whIssueId);
    if (CODE.SUCCESS === resSummary?.data?.code) {
      setSummaryStatus(resSummary.data.data);
    };
  }
  const handlerSearchKeyWorld = () => {
    setPage(DEFAULT_PAGE_INDEX);
    setRowsPerPage(20);
    updatePageData()
  }


  useEffect(() => {
    setSearchData({
      ...searchData,
      keyword: barcode
    })
    updatePageData(barcode);
  }, [barcode]);

  const updatePageData = async (keySearch?: any) => {
    try {
      setIsLoading(true);
      const { data } = await searchPhieuTuTruc({
        ...searchData,
        keyword: searchData?.keyword ? searchData?.keyword?.trim() : keySearch || null,
        doCreationFromDate: formatDateFromDTOCustom(searchData?.doCreationFromDate),
        doCreationToDate: formatDateToDTOCustom(searchData?.doCreationToDate),
        pageIndex: page,
        pageSize: rowsPerPage,
        type: modelId.type,
        warehouseId: !modelId.title ? null : (tuTrucCurrent as any)?.id ?? 0,
        whIssueId: modelId.whIssueId
      });
      await getDataSumary((tuTrucCurrent as any)?.id);
      if (CODE.SUCCESS === data.code) {
        setDsPhieuTuTruc(data?.data?.content);
        setConfigTable({
          totalPages: Math.ceil(data.data.pageable.totalElements / data.data.pageable.pageSize),
          totalElements: data.data.pageable.totalElements,
          numberOfElements: data.data.pageable.pageSize,
        });
      } else {
        toast.error('Lỗi tìm kiếm phiếu, vui lòng thử lại');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialogThemMoi(false);
    setOpenDialogConfirmDelete(false);
    setItemSelected({});
    setDsVatTu([]);
    updatePageData();
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      const response = await deletePhieuTuTruc(itemSelected.id);
      if (CODE.SUCCESS === response.status) {
        toast.success(`Xóa ${modelId.title} thành công`);
        handleCloseDialog();
      } else {
        toast.error('Có lỗi xảy ra, vui lòng thử lại');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const columnsActions = {
    Header: (props: any) => (
      <TableCustomHeader<any>
        tableProps={props}
        title={"Thao tác"}
        className='text-center text-light spaces max-w-50'
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => {
      return (
        (
          <div className="d-flex justify-content-center gap-3">
            <CustomIconButton
              variant="edit"
              onClick={() => {
                setItemSelected(props.cell.row.original);
                setOpenDialogThemMoi(true);
              }}
            >
              <i className={`spaces bi bi-pencil-square text-navy ${(props.cell.row.original?.statusCode !== WMS_STATUS.warehouse_new && modelId.title) ? 'mx-0' : 'mr-5'}`}></i>
            </CustomIconButton>

            {modelId.title && props.cell.row.original?.statusCode === WMS_STATUS.warehouse_new && <CustomIconButton
              // disabled={props.cell.row.original?.statusCode !== WMS_STATUS.warehouse_new}
              variant="delete"
              onClick={() => {
                setItemSelected(props.cell.row.original);
                setOpenDialogConfirmDelete(true);
              }}
            >
              <i className="bi bi-trash3-fill text-danger"></i>
            </CustomIconButton>
            }
          </div>
        )
      )
    }
  };

  return (
    <div className="bg-white h-100">
      <div className="flex-1 flex flex-column">
        <div className="d-flex bg-gray ">
          <div className="spaces width-100 bg-gray radius-2">
            <div className="flex justify-content-between bg-white spaces w-100 pt-6">
              <h4 className="text-title text-pri fw-bold fs-4 spaces mb-0 px-10 custom-title">
                {SITE === 'RHM' ? 'Danh sách hàng hóa' : `Danh sách ${modelId.title}`}
              </h4>
            </div>
            <div className="d-flex mt-1 flex-column spaces width-100">
              <div className="bg-white">
                <div className="d-flex spaces pr-8 mt-6 bg-white justify-content-between align-items-center mb-6">
                  <div className=" bg-white flex align-items-center ">
                    {modelId.title &&
                      <Button disabled={!(tuTrucCurrent as any)?.id} className="btn-fill mx-2 ml-10 spaces min-w-90px btn btn-primary" onClick={() => setOpenDialogThemMoi(true)}>
                        <i className='bi bi-plus-lg text-pri fs-3'></i> Thêm
                      </Button>
                    }
                  </div>
                  <div className="d-flex spaces mx-10 ">
                    <TextField
                      label="Từ ngày"
                      name="doCreationFromDate"
                      type="date"
                      value={searchData?.doCreationFromDate || ''}
                      className="flex"
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                    />
                  </div>
                  <div className="d-flex spaces mr-10">
                    <TextField
                      label="Đến ngày"
                      name="doCreationToDate"
                      type="date"
                      className="flex"
                      value={searchData?.doCreationToDate || ''}
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                    />
                  </div>
                  <div className="flex-grow-1 ">
                    <InputSearch
                      name="keyword"
                      value={searchData?.keyword || ''}
                      placeholder="Tìm kiếm"
                      handleChange={handleChangeSearchData}
                      handleSearch={handlerSearchKeyWorld}
                      handleKeyDown={(e: React.KeyboardEvent) => e.key === KEY.ENTER && handlerSearchKeyWorld()}
                      className="spaces h-31 pr-4  radius-3"
                    />
                  </div>
                </div>
                <div className=" spaces bg-white mb-0">
                  <TableCustom<any>
                    className={`spaces ${modelId?.className ? modelId?.className : "h-calc-vh-250"}`}
                    data={dsPhieuTuTruc}
                    columns={BSCoSoTuTrucColumns}
                    columnsActions={columnsActions}
                    verticalScroll={true}
                    selectionMode={SELECTION_MODE.SINGLE_NO_RADIO_BUTTON}
                  />
                  <TablePagination
                    handlePagesChange={handlePagesChange}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    rowsPerPage={rowsPerPage}
                    rowsForPage={rowsForPage}
                    page={page}
                    setPage={setPage}
                    setRowsPerPage={setRowsPerPage}
                    totalPages={configTable.totalPages}
                    totalElements={configTable.totalElements}
                    numberOfElements={configTable.numberOfElements}
                    hideTotalElements
                    customComponent={<WfStatusSummary summaryStatus={summaryStatus} col={2} />}
                    customComponentClassName="min-w-900px"
                    className="border border-0"
                  />
                </div>
              </div>
            </div>
          </div>
          {openDialogThemMoi &&
            <DialogThemPhieuTuTruc
              show={openDialogThemMoi}
              onHide={handleCloseDialog}
              initialValues={{
                [modelId.id]: {
                  ...itemSelected,
                  whReceive: itemSelected?.whReceive || tuTrucCurrent,
                  createdBy: dataUser?.sub,
                  // code: null,
                  // codePhieu: itemSelected?.code
                }
              }}
              typeTuTruc={typeTuTruc}
              modelId={modelId}
            />
          }
          {openDialogConfirmDelete &&
            <ConfirmDialog
              show={openDialogConfirmDelete}
              onCloseClick={handleCloseDialog}
              onYesClick={handleDelete}
              title="Xóa phiếu"
              message={`Bạn chắc chắn muốn xóa phiếu: ${itemSelected.code} ?`}
              yes="Xóa"
              close="Hủy"
            />
          }
        </div>
      </div>
    </div>
  );
};

export default withBarcodeScan(BoSungCoSoTuTruc);
